import React, { useEffect, useMemo } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { useSearchParams } from 'react-router-dom';
import OperateTitle from '@/pages/Maintenance/Executive/components/OperateTitle';
import Form from '@/components/Form';
import { setUploadFiles } from '@/slices/execFlowSlice';
import Upload from '../FlowSteps/components/Upload';

function UploadPackages({ steps, clusterId, setUploadFiles }) {
  const [searchParams] = useSearchParams();
  const flowId = Number(searchParams.get('flowId'));

  // 需要上传文件的步骤
  const uploadSteps = useMemo(
    () => steps.filter((step) => step.stencilType === 2 && step.task === 20),
    [steps],
  );

  // 初始化上传文件
  useEffect(() => {
    setUploadFiles(
      uploadSteps.map((item) => ({
        stepId: item.stepId,
      })),
    );
  }, [uploadSteps, setUploadFiles]);

  const uploadFormChange = (changed, values) => {
    const array = [];
    values.data?.forEach((item) => {
      const { file, ...others } = item;
      const params = {
        ...others,
      };
      if (file && file[0]) {
        const { raw, status, ...others } = file[0];
        // 上传成功才添加
        if (status === 'success') {
          params.fileName = others.name;
        } else {
          delete params.fileName;
        }
      }
      array.push(params);
    });

    setUploadFiles(array);
  };

  return isEmpty(uploadSteps) ? null : (
    <Root className='fadeIn'>
      <OperateTitle title='文件上传' />
      <Form style={{ padding: '10px 20px' }} onValuesChange={uploadFormChange}>
        {uploadSteps.map((step, index) => (
          <Line key={step.id}>
            <Form.FormItem
              name={['data', index, 'stepId']}
              initialValue={step.stepId}
              style={{ display: 'none' }}
            />
            <Form.FormItem
              name={['data', index, 'file']}
              labelWidth={'auto'}
              label={`${step.stepName}`}
            >
              <Upload data={{ clusterId, flowId, stepId: step.stepId }} />
            </Form.FormItem>
          </Line>
        ))}
      </Form>
    </Root>
  );
}

export default connect(
  (state) => ({
    steps: state.execFlow.steps,
    clusterId: state.execFlow.currentCluster?.id,
  }),
  {
    setUploadFiles,
  },
)(UploadPackages);

const Root = styled.div`
  border-radius: 8px;
  border: 1px solid #e1e1e1;
  margin-bottom: 16px;
`;

const Line = styled.div`
  display: flex;
  margin: 5px 0;
`;
